import { useInstance, createRef } from 'intact-vue';
import { useDraggable as useBaseDraggable } from '../../hooks/useDraggable';
export function useDraggable(showValue, fixValue, triggerChangeEvent, showTooltip) {
  var instance = useInstance();
  var trackRef = createRef();
  var firstThumbRef = createRef();
  var secondThumbRef = createRef();
  var _isFirst2 = true;
  var oldValue;
  var _useBaseDraggable = useBaseDraggable({
      onMove: function onMove(e) {
        var tempValue = getNewValue(getSlidingValue(e.clientX));
        fixValue(tempValue, false);
        showTooltip();
      },
      onEnd: function onEnd() {
        if (instance.$unmounted) return;
        (_isFirst2 ? firstThumbRef.value : secondThumbRef.value).blur();
        showValue.set(instance.get('value'));
        triggerChangeEvent(oldValue);
      }
    }),
    start = _useBaseDraggable.start,
    dragging = _useBaseDraggable.dragging;
  function onStart(e) {
    if (instance.get('disabled')) return;
    // remain the old value to detect whether it changed to trigger change event
    oldValue = instance.get('value');
    // use Focusin to set the flag, because it will be used on operating by keyboard
    // isFirst = _isFirst;
    start(e);
  }
  function getSlidingValue(pos) {
    var rect = trackRef.value.getBoundingClientRect();
    var percent = (pos - rect.left) / rect.width;
    var _instance$get = instance.get(),
      max = _instance$get.max,
      min = _instance$get.min;
    var sliderWidth = max - min;
    if (percent <= 0) {
      return min;
    } else if (percent >= 1) {
      return max;
    } else {
      return min + sliderWidth * percent;
    }
  }
  function getNewValue(value) {
    var _instance$get2 = instance.get(),
      range = _instance$get2.range,
      oldValue = _instance$get2.value;
    if (!range) return value;
    var min = oldValue[0],
      max = oldValue[1];
    if (_isFirst2) {
      if (value > max) {
        // exchange the thumb
        _isFirst2 = false;
        firstThumbRef.value.blur();
        secondThumbRef.value.focus();
        return [max, value];
      } else {
        return [value, max];
      }
    } else {
      if (value < min) {
        // exchange the thumb
        _isFirst2 = true;
        firstThumbRef.value.focus();
        secondThumbRef.value.blur();
        return [value, min];
      } else {
        return [min, value];
      }
    }
  }
  function onFocusin(_isFirst) {
    _isFirst2 = _isFirst;
    showTooltip();
  }
  return {
    onStart: onStart,
    dragging: dragging,
    trackRef: trackRef,
    firstThumbRef: firstThumbRef,
    secondThumbRef: secondThumbRef,
    isFirst: function isFirst() {
      return _isFirst2;
    },
    onFocusin: onFocusin,
    getNewValue: getNewValue,
    getSlidingValue: getSlidingValue
  };
}